// extracted by mini-css-extract-plugin
export var logo = "_iu-2";
export var logoWrapper = "_iu-1";
export var strip = "_iu-0";